"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-types */
const core_1 = require("@angular/core");
const deep_extend_1 = __importDefault(require("deep-extend"));
const buffer_1 = require("buffer");
const just_clone_1 = __importDefault(require("just-clone"));
let ObjectService = class ObjectService {
    constructor() {
        this.mergeObjects = (object, source) => {
            global.Buffer = global.Buffer || buffer_1.Buffer;
            return (0, deep_extend_1.default)(object, source);
        };
        this.mergeObjectsOnlyCommon = (object, source) => {
            const returnObject = this.deepCopy(object);
            Object.keys(source).forEach((key) => {
                if (key in returnObject) {
                    returnObject[key] = source[key];
                }
            });
            return returnObject;
        };
        /** Convert an object of key value pairs to an
         * array with objects containing `key` and `value` keys. */
        this.convertKeyValueObjectToArray = (object) => {
            const tempArray = [];
            for (const [key, value] of Object.entries(object)) {
                tempArray.push({
                    key,
                    value,
                });
            }
            return tempArray;
        };
    }
    deepCopy(object) {
        return (0, just_clone_1.default)(object);
    }
};
ObjectService = __decorate([
    (0, core_1.Injectable)()
], ObjectService);
exports.default = ObjectService;
